import React from 'react';
import { Globe, MapPin, Swords, TrendingUp } from 'lucide-react';
import { Heading } from '../../layout';
import { useUIColors } from '../../../hooks/useTheme';

const CARDS = [
  {
    icon: TrendingUp,
    title: 'Tamaño y tendencia',
    body: 'Seguimiento del mercado de aditivos: demanda, crecimiento y focos comerciales.',
  },
  {
    icon: MapPin,
    title: 'Geografía',
    body: 'Cobertura por país, región y canal para priorizar prospección y expansión.',
  },
  {
    icon: Swords,
    title: 'Competencia',
    body: 'Lectura de mercado frente a competidores, sin mezclarla con la ficha de producto.',
  },
];

const AdditiveMarketWorkspace = ({ isDarkMode = false }) => {
  const ui = useUIColors();

  return (
    <div>
      <Heading level={2} isDarkMode={isDarkMode}>
        <Globe size={24} style={{ marginRight: 8, verticalAlign: 'middle' }} />
        Mercado
      </Heading>
      <p style={{ margin: '4px 0 16px', color: ui.muted, fontSize: 14 }}>
        Inteligencia de mercado del negocio de aditivos: dónde jugar, con quién y con qué prioridad.
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 12,
        }}
      >
        {CARDS.map((card) => {
          const Icon = card.icon;
          return (
            <div
              key={card.title}
              style={{
                border: `1px solid ${ui.border}`,
                borderRadius: 12,
                background: ui.panel,
                padding: 16,
                minHeight: 140,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  display: 'grid',
                  placeItems: 'center',
                  background: isDarkMode ? 'rgba(22, 163, 74, 0.18)' : 'rgba(22, 163, 74, 0.1)',
                  color: '#16a34a',
                  marginBottom: 10,
                }}
              >
                <Icon size={18} />
              </div>
              <div style={{ fontWeight: 700, fontSize: 14, color: ui.text, marginBottom: 6 }}>
                {card.title}
              </div>
              <div style={{ fontSize: 13, color: ui.muted, lineHeight: 1.45 }}>{card.body}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdditiveMarketWorkspace;
